import * as Yup from "yup";

export interface RelatedEventsLogsResponseModel {
    fileId: string;
    docId: string;
    eventId: string;       // Unique event ID
    eventTime: string;     // Timestamp of the event
    imgStatus: string;        // Status of the event (e.g., "success")
    isPgmHalt: string;   // Indicates if the program halted (e.g., "N")
    event: string;     // Type of the event
    eventSource: string;   // Source of the event
    eventDetails: string;  // Description of the event
    associatedUser: string;
    associatedEmail: string;
}

export interface RelatedEventsLogsResponseItemModel {
    fileId: string;
    docId: string;       // Unique event ID
    docType: string;     // Timestamp of the event
    docStatus: string;        // Status of the event (e.g., "success")
    probill: string;   // Indicates if the program halted (e.g., "N")
    customerNumber: string;     // Type of the event
    customerName: string;   // Source of the event
    bol: string;  // Description of the event
    po: string;       // Unique event ID
    terminal: string;     // Timestamp of the event
    terminalName: string;
    image: string;
    failedeventsCount: string;
    events: RelatedEventsLogsResponseModel[];
}
export interface RelatedEventsLogsItemModel {
    page: number;                      // Current page number
    pageSize: number;                  // Number of records per page
    totalRecords: number;              // Total number of records available
    totalPages: number;                // Total number of pages
    data: RelatedEventsLogsResponseItemModel[];
}

export interface RelatedEventsLogsFilterModel {
    eventId?: string | undefined;
};

export interface RelatedEventsTableInfoModel {
    title: string,
    description: string,
    sections: []
}
export const RelatedEventsLogsFilterSchema: Yup.ObjectSchema<RelatedEventsLogsFilterModel> = Yup.object()
    .shape({
        eventId: Yup.string()
            .matches(/^\d+$/, "Only whole numbers are allowed.")
            .min(6, "Document ID must be greater than 100000 or empty.")
    }).defined()

